import './shared';
import './modules/front';
import React from 'react';
import ReactDOM from 'react-dom';
import ItemDatePicker from './modules/front/ItemDatePicker';
// import './modules/front/slick-theme.scss'
import './forms/make-form-persistent';

// Webpack HMR

if (module.hot) {
	module.hot.accept();
}
/*
const e = React.createElement;
const domContainer = document.querySelector('#item_date_picker_container');
const root = ReactDOM.createRoot(domContainer);
root.render(e(ItemDatePicker));

*/